import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import HomeNavBar from '../Shared/HomeNavBar/HomeNavBar';
import Footer from '../Shared/Footer/Footer';

const AppRouter = () => {
    const location = useLocation();
    
    // Check if current path includes '/reviewer'
    const isAuthorRoute = location.pathname.includes('/author');
    const isAdminRoute = location.pathname.includes('/admin');
    const isReviewerRoute = location.pathname.includes('/reviewer');

    return (
        <div>
            <HomeNavBar />
            <Outlet />
            {/* Render footer only if not in reviewer section */}
            {!isAuthorRoute && !isAdminRoute && !isReviewerRoute && <Footer />}
        </div>
    );
};

export default AppRouter;